import { StatusTagProps } from "@portal/BaseComponents/Table/Components/StatusTag/StatusTag";
import { AssociatedInvoice } from "./invoice";

export const paymentStatus = [
  "VOID",
  "UNAPPLIED",
  "FULLY_APPLIED",
  "PARTIALLY_APPLIED",
  "APPLIED",
] as const;

const payment_sort_col = [
  "AMOUNT",
  "CUSTOMER_NAME",
  "PAYMENT_DATE",
  "APPLIED_AMOUNT",
  "UNAPPLIED_AMOUNT",
  "DEFAULT",
  "STATUS",
  "INVOICE",
  "PAYMENT_AMOUNT",
  "REFERENCE",
  "MODE",
] as const;

export type PaymentSortCol = (typeof payment_sort_col)[number];

export type PaymentStatus = (typeof paymentStatus)[number];

export type PaymentConfigs = {
  statusConfig: {
    [key in PaymentStatus]: { label: string; style: StatusTagProps["style"] };
  };
};
export interface PaymentList {
  id: string;
  invoices: AssociatedInvoice[];
  currency: string;
  amount: number;
  amount_base_currency: number;
  mode?: string;
  date: string;
  reference_no: string;
  status: PaymentStatus;
  note?: string;
  customer_id: string;
  amount_customer_currency: number;
  applied_amount_customer_currency: number;
  un_applied_amount_customer_currency: number;
  invoice_payments: Record<string, Array<InvoicePayment>>;
}

export interface PaymentDetails extends PaymentList {
  applied_amount: number;
  un_applied_amount: number;
  applied_amount_base_currency: number;
  un_applied_amount_base_currency: number;
}

export interface InvoicePayment {
  currency: string;
  amount: number;
  id: string;
  invoice_id: string;
  payment_id: string;
  exchange_rate: number;
  tax_amount_withheld: number;
  amount_base_currency: number;
  tax_amount_withheld_base_currency: number;
  created_by_user_id: string;
  updated_by_user_id: string;
  created_at: string;
  updated_at: string;
}
